// extracted by mini-css-extract-plugin
export default {"container":"Explorar_container__qj8fJ","container__head":"Explorar_container__head__A1Wuy"};